import React from "react";
import { BasePage } from "app/types/PageTypes";
import { Redirect, Switch } from "react-router-dom";

const CouponsPage = (props: BasePage) => {
  return (
    <Switch>
      {props.children}
      <Redirect to="/coupons/promotional" />
    </Switch>
  );
};

export default CouponsPage;
